import { setConfiguration } from 'mytours-read-common'

import stqryBunnyReadApi from '../api/stqryBunnyReadApi'
import {
	customiseReducers,
	customiseReduxMiddleware,
	getDefaultApiConfiguration,
	getDirectApiBaseUrl,
	downloadFile,
	getFileDownloadPath,
	changeLocalizationLanguage,
	changeTheme,
	getCdnApiBaseUrl,
	preDownloadImage,
	getPlatform,
	getDeviceUUID,
	getApiHeaders,
} from '../platform'
import navigationSagas from '../navigation/sagas'
import {
	saveCollectionItemsToDisk,
	loadCollectionItemsFromDisk,
	removeCollectionItemsFromDisk,
	loadCollectionDetailsFromDisk,
	saveCollectionDetailsToDisk,
	removeCollectionDetailsFromDisk,
	loadMapRouteFromDisk,
	saveMapRouteToDisk,
	removeMapRouteFromDisk,
} from '../collection/functions'
import {
	saveScreenToDisk,
	loadScreenFromDisk,
	removeScreenFromDisk,
	checkFileExists,
	loadMediaItemFromDisk,
	saveMediaItemToDisk,
	removeMediaItemFromDisk,
	loadFormFromDisk,
	saveFormToDisk,
	removeFormFromDisk,
} from '../screen/functions'
import {
	getAccountId,
	getDefaultAppInfo,
	shouldUsePublishedContent,
	saveAppMetaDataToDisk,
	loadAppMetaDataFromDisk,
	getLanguages,
	saveAppManifestToDisk,
	loadAppManifestFromDisk,
} from '../settings/functions'
import { handleAppUpgrade } from '../home/functions'
import { saveCouponCodeToDisk, loadCouponCodesFromDisk, removeCouponCodeFromDisk } from '../lockapp/functions'
import {
	extractCollectionListParamsFromNavigationProps,
	extractCollectionItemsParamsFromNavigationProps,
} from '../collection/types'

export default () =>
	setConfiguration({
		// Env vars
		getDefaultApiConfiguration,
		getDirectApiBaseUrl,
		getApiHeaders,
		getCdnApiBaseUrl,
		getDefaultAppInfo,
		getAccountId,
		shouldUsePublishedContent,
		stqryBunnyReadApi,
		// Reducer/Sagas
		customiseReduxMiddleware,
		customiseReducers,
		getSagas: navigationSagas,
		// Container functions
		convertCollectionItemsContainerOwnProps: extractCollectionItemsParamsFromNavigationProps,
		convertCollectionListContainerOwnProps: extractCollectionListParamsFromNavigationProps,
		// Collection functions
		saveCollectionItemsToDisk,
		loadCollectionItemsFromDisk,
		removeCollectionItemsFromDisk,
		loadCollectionDetailsFromDisk,
		saveCollectionDetailsToDisk,
		removeCollectionDetailsFromDisk,
		// Map route functions
		saveMapRouteToDisk: saveMapRouteToDisk,
		loadMapRouteFromDisk: loadMapRouteFromDisk,
		removeMapRouteFromDisk: removeMapRouteFromDisk,
		// Screen functions
		loadScreenFromDisk,
		saveScreenToDisk,
		removeScreenFromDisk,
		// Media functions
		loadMediaItemFromDisk,
		saveMediaItemToDisk,
		removeMediaItemFromDisk,
		checkFileExists,
		// Form functions
		loadFormFromDisk,
		saveFormToDisk,
		removeFormFromDisk,
		// Download FIle
		downloadFile,
		getFileDownloadPath,
		preDownloadImage,
		// Settings functions
		saveAppMetaDataToDisk,
		loadAppMetaDataFromDisk,
		saveAppManifestToDisk,
		loadAppManifestFromDisk,
		handleAppUpgrade,
		changeLocalizationLanguage,
		changeTheme,
		getLanguages,
		getPlatform,
		getDeviceUUID,
		// Coupon codes
		saveCouponCodeToDisk,
		loadCouponCodesFromDisk,
		removeCouponCodeFromDisk,
	})
